import { Dialog } from '@headlessui/react'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import background from '../assets/img/Galaktika_BG_Login.jpg'
import Logo from '../assets/img/Galaktika_Logo_Login.png'
import Galaktika_Logo from '../assets/img/Galaktika_Logo.png'
import { ParticlesAnim } from '../components/particles/particles'
import Popup from '../components/ui/Popup'
import StatusPopup from '../components/ui/StatusPopup'
import { setPopUp } from '../features/popUpSlice/popUpSlice'
import { getWaxUser, getAnchorUser } from '../features/user/userSlice'
import { clearLocal } from '../utilities/clearLocal'

const Login = () => {
  const popUp = useSelector((state) => state.popUp)
  const user = useSelector((state) => state.user.userAccount)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (!user) {
      if (localStorage.getItem('ual-session-authenticator') === 'Anchor') {
        console.log('Getting Anchor')
        dispatch(getAnchorUser())
      } else if (localStorage.getItem('ual-session-authenticator') === 'Wax') {
        console.log('Getting Wax')
        dispatch(getWaxUser())
      }
    }
  }, []) // Trying to persist user data so you don't have to relogin (pseudo-autologin)

  useEffect(() => {
    if (user) {
      navigate('/mission')
    }
  }, [user, navigate])

  return (
    <div
      style={{ backgroundImage: `url(${background})` }}
      className="bg-cover bg-center bg-no-repeat grid grid-rows-3 justify-items-center text-center login__bg h-screen w-screen overflow-hidden"
    >
      <ParticlesAnim />
      <div className="pos-rel z-30 flex items-center w-full logo-text">
        <img alt="Galaktika Logo Text" src={Logo}></img>
      </div>
      <div className="logo-main self-center mb-20 pos-rel z-30">
        <img alt="Galaktika Logo" src={Galaktika_Logo}></img>
      </div>
      <Popup>
        <div className="mt-4 relative z-50 flex flex-col items-center justify-center login-popup__wrapper w-48">
          <button
            className="px-3 transition button__wrapper"
            onClick={() => {
              dispatch(getWaxUser())
            }}
          >
            <div className="hover:scale-105 duration-300 ease-in-out transition-all wax-button w-4/5"></div>
          </button>
          <button
            className="px-3 transition button__wrapper"
            onClick={() => {
              dispatch(getAnchorUser())
            }}
          >
            <div className="hover:scale-105 duration-300 ease-in-out transition-all anchor-button w-4/5"></div>
          </button>
        </div>
      </Popup>
      <StatusPopup
        isOpen={popUp.isOpen}
        status={popUp.status}
        setIsOpen={() => dispatch(setPopUp({ isOpen: false }))}
      />
    </div>
  )
}

export default Login
